<template>
  <b-modal
    v-model="modal"
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @hidden="$emit('cancel')"
    @ok.prevent="saveAbsence"
    hide-header
  >
    <b-form>
      <app-input class="form-group" :model="$schema.code" />
      
      <app-input class="form-group" :model="$schema.name"/>
      
      <div class="form-group">
        <app-checkbox :model="$schema.isWorktime" />
      </div>

      <div class="form-group">
        <app-checkbox :model="$schema.displayAsWorktime" />
      </div>

      <div class="form-group">
        <app-checkbox :model="$schema.isPaid" />
      </div>

      <div class="form-group">
        <app-checkbox :model="$schema.isHoliday" />
      </div>
    </b-form>
  </b-modal>
</template>


<script>
import moment from 'moment';
import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/absence.schema';
import { AbsenceResource } from '@/resources/absence.resource';

export default {
  mixins: [formMixin],
  props: {
    item: Object,
    addModal: Boolean
  },
  schema,
  data() {
    return {
      modal: false,
      id: null,
      absence: {}
    };
  },
  methods: {
    // Zapisuje
    saveAbsence() {
      if (this.$schema.$validateAll().length === 0) {
        this.absence = { ...this.$schema.$model };
        if (this.id) {
          this.updateAbsence();
        } else {
          this.addAbsence();
        }
      }
    },
    // Dodaje
    addAbsence() {
      AbsenceResource.add(this.absence)
        .then(absence => {
          this.$schema.$reset();
          this.$emit('add', absence);
        })
        .catch(error => {
          this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas dodawania nieobecności' });
          console.warn(error);
        });
    },
    // Aktualizuje
    updateAbsence() {
      AbsenceResource.update(this.id, this.$schema.$model)
        .then(() => {
          this.$emit('edited', { id: this.id, ...this.$schema.$model });
          this.$schema.$reset();
        })
        .catch(error => {
          console.warn(error);
          this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas aktualizacji nieobecności' });
        });
    }
  },
  beforeMount() {
    this.modal = this.addModal;
    if (this.item) {
      this.id = this.item.id;
      this.$schema.$setData(this.item);
    }
  }
};
</script>
